import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "content-panel",
  style: {"max-width":"1000px"}
}
const _hoisted_2 = { class: "panel-header" }
const _hoisted_3 = { class: "panel-icon" }
const _hoisted_4 = { class: "panel-body" }
const _hoisted_5 = { class: "instruction-icon" }
const _hoisted_6 = {
  key: 0,
  class: "upload-empty-state"
}
const _hoisted_7 = { class: "empty-icon" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 1,
  class: "employees-table-card"
}
const _hoisted_10 = { class: "employees-table-header" }
const _hoisted_11 = { class: "employees-count" }
const _hoisted_12 = { class: "employees-table-wrapper" }
const _hoisted_13 = { class: "employee-cell" }
const _hoisted_14 = { class: "status-card-text" }
const _hoisted_15 = { class: "status-card-actions" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "confirm-dialog-header" }
const _hoisted_21 = { class: "confirm-dialog-footer" }
const _hoisted_22 = { class: "confirm-dialog-header warning" }
const _hoisted_23 = { class: "confirm-dialog-footer" }
const _hoisted_24 = { class: "boss-dialog-header" }
const _hoisted_25 = { class: "boss-dialog-body" }
const _hoisted_26 = { class: "boss-list" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "boss-name" }
const _hoisted_29 = { class: "boss-birth" }
const _hoisted_30 = { class: "boss-dialog-footer" }
const _hoisted_31 = ["disabled"]

import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';

interface EmployeeRow {
  [key: string]: any;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'StepOne',
  props: {
    employees: {},
    stepCompleted: { type: Boolean },
    isConfirmed: { type: Boolean },
    isConfirming: { type: Boolean }
  },
  emits: ["upload", "confirm", "release", "boss-updated"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useStore();

const employees = computed(() => props.employees || []);
const stepCompleted = computed(() => props.stepCompleted);
const isConfirmed = computed(() => !!props.isConfirmed);
const isConfirming = computed(() => !!props.isConfirming);
const hasEmployees = computed(() => employees.value.length > 0);
const canReupload = computed(() => stepCompleted.value && hasEmployees.value && !isConfirmed.value);

// 확정/해제 확인 다이얼로그 상태
const showConfirmDialog = ref(false);
const showReleaseDialog = ref(false);

// 대표자 설정 다이얼로그 상태
const showBossDialog = ref(false);
const selectedBossIdx = ref<number | null>(null);
const isSavingBoss = ref(false);

// 대표자 여부 확인
const isBoss = (employee: EmployeeRow) => {
  return employee.lem_isboss === 'Y' || employee.isBoss === 'Y';
};

// 선택된 대표자 여부 확인
const isSelectedBoss = (employee: EmployeeRow) => {
  const idx = employee.lem_idx || employee.idx;
  return selectedBossIdx.value === idx;
};

// 대표자 설정 다이얼로그 열기
const openBossDialog = () => {
  // 현재 대표자가 있으면 선택 상태로 설정
  const currentBoss = employees.value.find(emp => isBoss(emp));
  if (currentBoss) {
    selectedBossIdx.value = currentBoss.lem_idx || currentBoss.idx;
  } else {
    selectedBossIdx.value = null;
  }
  showBossDialog.value = true;
};

// 대표자 토글
const toggleBoss = (employee: EmployeeRow) => {
  const idx = employee.lem_idx || employee.idx;
  if (selectedBossIdx.value === idx) {
    selectedBossIdx.value = null;
  } else {
    selectedBossIdx.value = idx;
  }
};

// 대표자 저장
const saveBoss = async () => {
  const user = store.state.user;
  if (!user || !user.m_sisul_code) {
    store.commit('showSnackbar', { text: '사용자 정보를 찾을 수 없습니다.', color: 'error' });
    return;
  }

  try {
    isSavingBoss.value = true;
    
    const response = await axios.post('/api/emp/set-boss', {
      sisulCode: user.m_sisul_code,
      bossIdx: selectedBossIdx.value
    }, { withCredentials: true });

    if (response.data.success) {
      store.commit('showSnackbar', { text: '대표자가 설정되었습니다.', color: 'success' });
      showBossDialog.value = false;
      emit('boss-updated');
    } else {
      store.commit('showSnackbar', { text: response.data.message || '대표자 설정에 실패했습니다.', color: 'error' });
    }
  } catch (error: any) {
    console.error('대표자 설정 오류:', error);
    store.commit('showSnackbar', { text: '대표자 설정 중 오류가 발생했습니다.', color: 'error' });
  } finally {
    isSavingBoss.value = false;
  }
};

const handleUpload = () => {
  if (isConfirming.value) return;
  emit('upload');
};

const handleReupload = () => {
  if (!canReupload.value || isConfirming.value) return;
  emit('upload');
};

// 확정 버튼 클릭
const handleConfirm = () => {
  showConfirmDialog.value = true;
};

// 확정 진행
const proceedConfirm = () => {
  showConfirmDialog.value = false;
  emit('confirm');
};

// 해제 버튼 클릭
const handleRelease = () => {
  showReleaseDialog.value = true;
};

// 해제 진행
const proceedRelease = () => {
  showReleaseDialog.value = false;
  emit('release');
};

const formatDate = (value?: string | number | null) => {
  if (!value) return '-';
  const str = value.toString();
  if (str.includes('-')) return str;
  if (str.length === 8) {
    return `${str.slice(0, 4)}-${str.slice(4, 6)}-${str.slice(6, 8)}`;
  }
  return str;
};

const formatBirth = (value?: string | number | null) => {
  if (!value) return '-';
  const formatted = formatDate(value);
  return formatted === '-' ? '-' : formatted;
};

const formatGender = (value?: string | number | null) => {
  if (value === undefined || value === null) return '-';
  if (typeof value === 'string') {
    const normalized = value.trim().toUpperCase();
    if (['M', '남', 'MALE', '1'].includes(normalized)) return '남';
    if (['F', '여', 'FEMALE', '2'].includes(normalized)) return '여';
  }
  if (typeof value === 'number') {
    return value === 1 ? '남' : value === 2 ? '여' : '-';
  }
  return '-';
};

const formatEmploymentPeriod = (start?: string | number | null, end?: string | number | null) => {
  const startFormatted = formatDate(start);
  const endFormatted = formatDate(end);
  if (startFormatted === '-' && endFormatted === '-') return '-';
  return `${startFormatted} ~ ${endFormatted === '-' ? '현재' : endFormatted}`;
};

const formatEmploymentPeriodDisplay = (employee: EmployeeRow) => {
  if (!employee) return '-';
  if (employee.workPeriod) return employee.workPeriod;

  const start =
    employee.workStartDate ??
    employee.work_start_date ??
    employee.lem_work_start_date;
  const end =
    employee.workEndDate ??
    employee.work_end_date ??
    employee.lem_work_end_date;

  return formatEmploymentPeriod(start, end);
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_icon, {
          size: "32",
          color: "#1e3a8a"
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
            _createTextVNode("mdi-account-group", -1)
          ]))]),
          _: 1
        })
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "panel-title-section" }, [
        _createElementVNode("h2", { class: "panel-title" }, "사원 정보 등록하기")
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: _normalizeClass(["instruction-card", { 'move-bottom': hasEmployees.value }])
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_v_icon, { color: "#1e3a8a" }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode("mdi-monitor-arrow-down", -1)
            ]))]),
            _: 1
          })
        ]),
        _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"instruction-content\"><h4>파일 다운로드 안내</h4><ol><li>장기요양정보시스템 접속 후 우측 상단 <strong>기타</strong> &gt; <strong>엑셀 다운로드</strong>를 클릭합니다.</li><li>원하는 탭(요양보호사 정보/청구내역/청구내역 상세)을 선택하고 <strong>엑셀 다운로드</strong> 버튼을 누릅니다.</li><li>브라우저 저장 창에서 <strong>Ctrl + Shift + S</strong>로 파일을 저장해 주세요.</li></ol></div>", 1))
      ], 2),
      (!hasEmployees.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_v_icon, {
                size: "56",
                color: "#94a3b8"
              }, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createTextVNode("mdi-cloud-upload", -1)
                ]))]),
                _: 1
              })
            ]),
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "empty-text" }, [
              _createElementVNode("p", null, "사원 정보 파일을 업로드하면 자동으로 목록이 채워집니다."),
              _createElementVNode("span", null, "장기요양정보시스템에서 다운로드한 엑셀을 그대로 업로드하세요.")
            ], -1)),
            _createElementVNode("button", {
              class: "btn-primary-large",
              onClick: handleUpload,
              disabled: isConfirming.value
            }, [
              _createVNode(_component_v_icon, { class: "btn-icon" }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode("mdi-cloud-upload", -1)
                ]))]),
                _: 1
              }),
              _cache[12] || (_cache[12] = _createElementVNode("span", null, "사원 정보 파일 업로드하기", -1))
            ], 8, _hoisted_8)
          ]))
        : _createCommentVNode("", true),
      (employees.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _cache[14] || (_cache[14] = _createElementVNode("div", null, [
                _createElementVNode("h4", null, "등록된 사원 정보"),
                _createElementVNode("p", { class: "header-subtitle" }, "업로드된 사원 데이터 전체를 확인하세요")
              ], -1)),
              _createElementVNode("span", _hoisted_11, _toDisplayString(employees.value.length) + "명", 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("table", null, [
                _cache[17] || (_cache[17] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "성명"),
                    _createElementVNode("th", null, "생년월일"),
                    _createElementVNode("th", null, "성별"),
                    _createElementVNode("th", null, "보유 자격증"),
                    _createElementVNode("th", null, "근무기간")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(employees.value, (employee, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: employee.lem_idx || index
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_v_icon, {
                            size: "18",
                            color: "#1e3a8a",
                            class: "cell-icon"
                          }, {
                            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                              _createTextVNode("mdi-account", -1)
                            ]))]),
                            _: 1
                          }),
                          _createElementVNode("span", null, _toDisplayString(employee.name || employee.lem_name || '이름 없음'), 1),
                          (isBoss(employee))
                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                key: 0,
                                color: "#10b981",
                                size: "x-small",
                                variant: "flat",
                                class: "boss-chip"
                              }, {
                                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                  _createTextVNode(" 대표자 ", -1)
                                ]))]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(formatBirth(employee.birthDate || employee.lem_birth)), 1),
                      _createElementVNode("td", null, _toDisplayString(formatGender(employee.gender || employee.lem_gender)), 1),
                      _createElementVNode("td", null, _toDisplayString(employee.qualification || employee.lem_license || '-'), 1),
                      _createElementVNode("td", null, _toDisplayString(formatEmploymentPeriodDisplay(employee)), 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (hasEmployees.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(["status-card", isConfirmed.value ? 'info' : 'success'])
          }, [
            _createVNode(_component_v_icon, {
              color: isConfirmed.value ? '#10b981' : '#00C73C',
              size: "24"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(isConfirmed.value ? 'mdi-lock-check' : 'mdi-check-circle'), 1)
              ]),
              _: 1
            }, 8, ["color"]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("h4", null, _toDisplayString(isConfirmed.value ? '사원 정보 확정됨' : '사원 정보 업로드 완료'), 1),
              _createElementVNode("p", null, _toDisplayString(isConfirmed.value
              ? '확정 상태예요. 해제 후에만 사원 정보를 수정하거나 재업로드할 수 있습니다.'
              : `${employees.value.length}명의 사원 정보가 등록되었습니다. 확정을 눌러 다음 단계로 진행하세요.`), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("button", {
                class: "btn-outline",
                onClick: handleReupload,
                disabled: !canReupload.value || isConfirming.value
              }, " 재업로드 ", 8, _hoisted_16),
              (isConfirmed.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn-outline",
                    onClick: handleRelease,
                    disabled: isConfirming.value
                  }, [
                    (isConfirming.value)
                      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                          key: 0,
                          indeterminate: "",
                          size: "16",
                          width: "2",
                          color: "#047857",
                          class: "mr-1"
                        }))
                      : _createCommentVNode("", true),
                    _cache[18] || (_cache[18] = _createTextVNode(" 확정 해제 ", -1))
                  ], 8, _hoisted_17))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("button", {
                      class: "btn-outline boss-btn",
                      onClick: openBossDialog,
                      disabled: !hasEmployees.value || isConfirming.value
                    }, [
                      _createVNode(_component_v_icon, {
                        size: "16",
                        class: "mr-1"
                      }, {
                        default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                          _createTextVNode("mdi-account-star", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[20] || (_cache[20] = _createTextVNode(" 대표자 설정하기 ", -1))
                    ], 8, _hoisted_18),
                    _createElementVNode("button", {
                      class: "btn-outline confirm-emphasis",
                      onClick: handleConfirm,
                      disabled: !hasEmployees.value || isConfirming.value
                    }, [
                      (isConfirming.value)
                        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                            key: 0,
                            indeterminate: "",
                            size: "16",
                            width: "2",
                            color: "#047857",
                            class: "mr-1"
                          }))
                        : _createCommentVNode("", true),
                      _cache[21] || (_cache[21] = _createTextVNode(" 사원 정보 확정하기 ", -1))
                    ], 8, _hoisted_19)
                  ], 64))
            ])
          ], 2))
        : _createCommentVNode("", true),
      _createVNode(_component_v_dialog, {
        modelValue: showConfirmDialog.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showConfirmDialog).value = $event)),
        "max-width": "440px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "confirm-dialog" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_v_icon, {
                  size: "48",
                  color: "#10b981"
                }, {
                  default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                    _createTextVNode("mdi-lock-check", -1)
                  ]))]),
                  _: 1
                }),
                _cache[23] || (_cache[23] = _createElementVNode("h3", null, "사원 정보 확정", -1))
              ]),
              _cache[24] || (_cache[24] = _createElementVNode("div", { class: "confirm-dialog-body" }, [
                _createElementVNode("p", null, "사원 정보를 확정하시겠습니까?"),
                _createElementVNode("p", null, "확정 후에는 사원 정보를 수정할 수 없습니다.")
              ], -1)),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("button", {
                  class: "btn-cancel",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showConfirmDialog.value = false))
                }, "취소"),
                _createElementVNode("button", {
                  class: "btn-confirm",
                  onClick: proceedConfirm
                }, "확정")
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        modelValue: showReleaseDialog.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showReleaseDialog).value = $event)),
        "max-width": "440px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "confirm-dialog" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_v_icon, {
                  size: "48",
                  color: "#f59e0b"
                }, {
                  default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                    _createTextVNode("mdi-alert-circle", -1)
                  ]))]),
                  _: 1
                }),
                _cache[26] || (_cache[26] = _createElementVNode("h3", null, "확정 해제", -1))
              ]),
              _cache[27] || (_cache[27] = _createElementVNode("div", { class: "confirm-dialog-body" }, [
                _createElementVNode("p", null, "사원 정보 확정을 해제하시겠습니까?"),
                _createElementVNode("p", null, "해제 후에는 다시 수정 및 재업로드가 가능합니다.")
              ], -1)),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("button", {
                  class: "btn-cancel",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (showReleaseDialog.value = false))
                }, "취소"),
                _createElementVNode("button", {
                  class: "btn-confirm warning",
                  onClick: proceedRelease
                }, "해제")
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        modelValue: showBossDialog.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showBossDialog).value = $event)),
        "max-width": "500px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "boss-dialog" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_v_icon, {
                  size: "32",
                  color: "#10b981"
                }, {
                  default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                    _createTextVNode("mdi-account-star", -1)
                  ]))]),
                  _: 1
                }),
                _cache[29] || (_cache[29] = _createElementVNode("h3", null, "대표자 설정", -1))
              ]),
              _createElementVNode("div", _hoisted_25, [
                _cache[31] || (_cache[31] = _createElementVNode("p", { class: "boss-dialog-desc" }, "대표자로 지정할 사원을 선택하세요.", -1)),
                _createElementVNode("div", _hoisted_26, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(employees.value, (employee, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: employee.lem_idx || index,
                      class: _normalizeClass(["boss-item", { 'selected': isSelectedBoss(employee) }]),
                      onClick: ($event: any) => (toggleBoss(employee))
                    }, [
                      _createVNode(_component_v_icon, {
                        size: "20",
                        color: isSelectedBoss(employee) ? '#10b981' : '#64748b'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(isSelectedBoss(employee) ? 'mdi-account-star' : 'mdi-account'), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"]),
                      _createElementVNode("span", _hoisted_28, _toDisplayString(employee.name || employee.lem_name), 1),
                      _createElementVNode("span", _hoisted_29, _toDisplayString(formatBirth(employee.birthDate || employee.lem_birth)), 1),
                      (isSelectedBoss(employee))
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            size: "20",
                            color: "#10b981",
                            class: "check-icon"
                          }, {
                            default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                              _createTextVNode(" mdi-check-circle ", -1)
                            ]))]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_27))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("button", {
                  class: "btn-cancel",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (showBossDialog.value = false))
                }, "취소"),
                _createElementVNode("button", {
                  class: "btn-confirm boss",
                  onClick: saveBoss,
                  disabled: isSavingBoss.value
                }, [
                  (isSavingBoss.value)
                    ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                        key: 0,
                        indeterminate: "",
                        size: "16",
                        width: "2",
                        color: "#fff",
                        class: "mr-1"
                      }))
                    : _createCommentVNode("", true),
                  _cache[32] || (_cache[32] = _createTextVNode(" 저장 ", -1))
                ], 8, _hoisted_31)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})